<template>
  <div class="manage-sim-wrapper">
    <div class="sim-passivate-wrapper" v-if="showSimPassivateCard">
      <div class="card" v-if="this.simCardStatus === 'ACTIVE'">
        <img src="/files/lidl/images/new-icons/svg/unlock-outline.svg" />
        <h3 class="text-xl"><span class="uppercase">Sim</span> sperren</h3>
        <p>Ist dir dein Endgerät abhanden gekommen oder befürchtest du anderen Missbrauch? Hier kannst du deine <span class="uppercase">Sim</span> kostenlos sperren.</p>
        <a class="button button--primary full-width text-sm" :href="btnLinkPassivate"><span class="uppercase">Sim</span> sperren</a>
      </div>
      <div class="card" v-if="this.simCardStatus === 'PASSIVATED' || this.currentStatus === 'Running'">
        <img src="/files/lidl/images/new-icons/svg/unlock-outline.svg" />
        <h3 class="text-xl" v-if="this.simCardStatus === 'PASSIVATED'"><span class="uppercase">Sim</span> gesperrt</h3>
        <h3 class="text-xl" v-if="this.currentStatus === 'Running'"><span class="uppercase">Sim</span> gesperrt (in Bearbeitung)</h3>
        <p>Eine Entsperrung der <span class="uppercase">Sim</span> kann aus Sicherheitsgründen nur telefonisch durch dich persönlich über die
          <a :href="customerSupportLink"><span class="uppercase">Lidl</span> <span lang="en">Connect</span> Kundenbetreuung</a> erfolgen.</p>
        <a aria-disabled="true" class="button button--primary full-width text-sm disabled"><span class="uppercase">Sim</span> sperren</a>
      </div>

    </div>
    <div class="sim-order-wrapper" v-if="showSimOrderCard">
      <div class="card" v-if="simOrderStatus_ === 'DEFAULT'">
        <img src="/files/lidl/images/new-icons/svg/arrow-right-arrow-left-outline.svg" />
        <h3 class="text-xl"><span class="uppercase">Sim</span> tauschen / ersetzen</h3>
        <p>Ist deine <span class="uppercase">Sim</span>-Karte beschädigt oder hast du ein neues Endgerät und brauchst einen anderen <span class="uppercase">Sim</span>-Kartentyp?</p>
        <a class="button button--primary full-width text-sm font-medium" :href="btnLinkOrder">Neue <span class="uppercase">Sim</span> tauschen / ersetzen</a>
      </div>
      <div class="card" v-if="simOrderStatus_ === 'ORDERED'">
        <img src="/files/lidl/images/new-icons/svg/arrow-right-arrow-left-outline.svg" />
        <h3 class="text-xl">Deine Ersatzkarte ist unterwegs</h3>
        <p>Aus Sicherheitsgründen versenden wir die <span class="uppercase">Sim</span>-Karten inaktiv per Post. Deine alte <span class="uppercase">Sim</span>-Karte bleibt so lange aktiviert, bis du deine Ersatzkarte nach Erhalt online oder telefonisch über die <a :href="customerSupportLink"><span class="uppercase">Lidl</span> <span lang="en">Connect</span> Kundenbetreuung</a> aktivierst.</p>
        <p>Nach 28 Tagen erfolgt eine automatische Aktivierung.</p>
      </div>
      <div class="card" v-if="simOrderStatus_ === 'DELIVERED'">
        <img src="/files/lidl/images/new-icons/svg/arrow-right-arrow-left-outline.svg" />
        <h3 class="text-xl">Ersatz-<span class="uppercase">Sim</span>-Karte aktivieren</h3>
        <p>Hast du deine Ersatz <span class="uppercase">Sim</span>-Karte erhalten? Bitte aktivier diese jetzt. Mit der Aktivierung werden alle anderen <span class="uppercase">Sim</span>-Karten deaktiviert. Bitte berücksichtige, dass die Aktivierung einige Minuten dauern könnte.</p>
        <button class="button button--primary full-width text-sm font-medium" @click="activate">Ersatz-<span class="uppercase">Sim</span>-Karte aktivieren</button>
      </div>
      <div class="card" v-if="simOrderStatus_ === 'ACTIVATED'">
        <img src="/files/lidl/images/new-icons/svg/arrow-right-arrow-left-outline.svg" />
        <h3 class="text-xl">Ersatz-<span class="uppercase">Sim</span>-Karte bestellen</h3>
        <p>Du hast in den letzten 30 Tagen eine Ersatz-<span class="uppercase">Sim</span>-Karte erhalten und aktiviert. Bitte wende dich an die <a :href="customerSupportLink"><span class="uppercase">Lidl</span> <span lang="en">Connect</span> Kundenbetreuung</a> falls du dennoch dringend eine neue <span class="uppercase">Sim</span>-Karte benötigst.</p>
      </div>
    </div>
    <div class="no-data-available" v-if="false">
      <div class="card">
        <p> Aktuell können keine Daten geladen werden. Bitte probiere es später erneut.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'

export default {
  name: 'SimCardWrapper',
  data() {
    return {
      loading: false,
      modalShow: false,
      simOrderStatus: '',
      currentCustomer: {
        contract: {
          simCard: {
            status: '',
            notification: {
              title: '',
              text: '',
              delay: ''
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('passivateSimCard', ['currentStatus']),
    simCardStatus() {
      return this.currentCustomer.contract.simCard.status
    },
    simOrderStatus_() {
      return this.simOrderStatus.simOrderStatus
    },
    slotData() {
      if (this.simCardStatus === 'PASSIVATED') {
        return {
          currentStatus: 'Passivated'
        }
      } else {
        return {
          currentStatus: this.currentStatus
        }
      }
    }
  },
  methods: {
    ...mapActions('substituteSimCard', ['activateSim']),
    refresh() {
      this.$apollo.queries.simOrderStatus.refresh()
    },
    activate () {
      this.loading = true
      this.activateSim()
        .then(() => {
          this.loading = false
        }, () => {
          this.loading = false
        })
    }
  },
  apollo: {
    simCardStatus: function() {
      const me = this
      return wrapQuery(
        gql`
          query passivateSIMCard {
            currentCustomer {
              contract {
                msisdn
                simCard {
                  status
                  notification {
                    title
                    text
                    delay
                  }
                }
              }
            }
          }
        `,
        this,
        'currentCustomer',
        {},
        function(data) {
          if (data.contract.simCard.status === 'PASSIVATED') {
            me.$store.commit(
              'addMessage',
              {
                type: 'success',
                message: data.contract.simCard.notification?.text
              },
              { root: true }
            )
          }
        }
      )
    },
    simOrderStatus: function() {
      return wrapQuery(
        gql`
          query simOrderStatus {
            simOrderStatus {
              simOrderStatus
            }
          }
        `,
        this,
        'simOrderStatus'
      )
    }
  },
  mixins: [slotProxy(), transaction('passivateSimCard')],
  props: {
    btnLinkPassivate: {
      type: String,
      default: '/mein-lidl-connect/sim-karte-verwalten/sim-sperren.html'
    },
    btnLinkOrder: {
      type: String,
      default: '/mein-lidl-connect/sim-karte-verwalten/sim-ersetzen.html'
    },
    customerSupportLink: {
      type: String,
      default: '/mein-lidl-connect/kontakt.html'
    },
    showSimPassivateCard: {
      type: Boolean,
      default: false
    },
    showSimOrderCard: {
      type: Boolean,
      default: false
    }
  }
}
</script>
